import { numberWithComma } from "../../Utils/helper";

export const yes = <span className="listing_table_yes">Yes</span>;
export const no = <span className="listing_table_no">No</span>;

export const yesNo = (
  condition,
  isReverse = false
) => {
  const yesClass = "listing_table_yes";
  const noClass = "listing_table_no";

  return condition ? (
    <span className={isReverse ? noClass : yesClass}>Yes</span>
  ) : (
    <span className={isReverse ? yesClass : noClass}>No</span>
  );
};

export const num = (v) => Number(v || 0);

export const money = (v) => `$${numberWithComma(Math.round(Number(v || 0)))}`;

export const isNumeric = (v) => /^\d+(\.\d+)?$/.test(v);

export const formatNumber = (v) =>
  Number(String(v).replace(/,/g, ""))
    .toFixed(0)
    .replace(/\B(?=(\d{3})+(?!\d))/g, ",");

export const isEmptyValue = (v) => v === "" || v === null || v === "0";

export const isEmpty = (v) => v === undefined || v === null || v === "";

